/**
 * Yield so the event loop can run (paint spinners, handle input).
 * Uses setTimeout(0) — requestIdleCallback does not run during long sync tasks.
 * @returns {Promise<void>}
 */
export function yieldToMain() {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

/** Lower-priority yield between heavy load phases. */
export function yieldToIdle() {
  return new Promise((resolve) => {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(() => resolve(), { timeout: 100 });
    } else {
      setTimeout(resolve, 0);
    }
  });
}

/** Wait until React/CSS can paint (e.g. after setState / loading overlay mount). */
export function yieldForPaint() {
  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(resolve);
    });
  });
}
